module.exports = __webpack_public_path__ + "images/psp/hero/car-hero.webp";